import React, { useState } from 'react';
// import images
import logo from "../../assets/images/logo.svg";
import { Link, useNavigate } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { toast } from 'react-toastify';
import LoaderModal from '../ModalLoader/LoaderModal';
const ResetPassword = () => {

// for loading modal ==>
  const [showModal, setShowModal] = useState(false);

const naviagtion=useNavigate();
  const APi_Url=process.env.REACT_APP_ENIGMA_API;
  const initialValues = {
    recoveryCode: "",
    newPassword: '',
    confirmPassword:''
    
  };

  const validationSchema = Yup.object({
    recoveryCode: Yup.string()
    .min(8, "RecoveryCode must be at least 8 characters")
    .required("RecoveryCode is Required"),
    newPassword: Yup.string().min(6, 'Newpassword must be at least 6 characters').required('Newpassword is Required'),
    confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
    .required('ConfirmPassword is Required')
  });



  const onSubmit = async (values, { setSubmitting }) => {
    setShowModal(true);
    // console.log('Form data', values.recoveryCode);
    const recoverycode=values.recoveryCode;
    const newpasswrod=values.newPassword;
    const confirmPassword=values.confirmPassword;
    
  
    // http://localhost:3000/forgotpassword
    try {
      const response = await axios.post(
        `${APi_Url}api/auth/reset-password/${recoverycode}/${newpasswrod}/${confirmPassword}`,
{},
        {
          headers: {
            
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            "secure": false,
   "changeOrigin": true
          }
        }
      );

      
      setShowModal(false);
      
      if(response.data.statusCode==400){
        toast.error(response.data.response)
      }
      
     if(response.data.statusCode==200){
      toast.success(response.data.response);
      naviagtion('/')
     }
      // Handle response data as needed
    } catch (error) {
      setShowModal(false);
      console.error('Error ', error);
    } finally {
      setSubmitting(false); // Make sure to reset form state, if applicable
    }
  
  };
  

  return (
    <>
    <div className="sign_in_wrp">
    <div className="sign_in_wrp_cntnr">
      <div className="sign_in_innr">
        <div className="sign_in_innr_wrp">
          <div className="img_prt">
              <img src={logo} alt="logo_icon"/>
              <h2> Welcome </h2>
              {/* <h2>Dashboard</h2> */}
          </div>
          <div className="cnct_prt">
            <div className="sign_in_cnct">
              <div className="sgn_pg_lgo">
                {/* <a href="#">
                  <img src={logo} alt="logo_icon"/>
                </a> */}
              </div>          
              <div className="frm_wrp">
                <h6>Reset Password</h6>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                  >
                    {({ isSubmitting }) => (
                <Form >
                    <div className="frm_fld">
                  <label>Recovery code</label>
                   
                   <Field type="text" id="recoveryCode" name="recoveryCode" placeholder="recoveryCode" className="input" />
                   <ErrorMessage name="recoveryCode" component="div" className="error_msg" />
                  </div>
                  <div className="frm_fld">
                  <label>New password</label>
                   
                   <Field type="password" id="newPassword" name="newPassword" placeholder="newPassword" className="input" />
                   <ErrorMessage name="newPassword" component="div" className="error_msg" />
                  </div>
                  <div className="frm_fld">
                  <label>Confirm password</label>
                   
                   <Field type="password" id="confirmPassword" name="confirmPassword" placeholder="confirmPassword" className="input" />
                   <ErrorMessage name="confirmPassword" component="div" className="error_msg" />
                  </div>
                 
                 
                  <div className="frm_fld">
                    <input type="submit" disabled={isSubmitting} value="Reset Password" />
                  </div>
                  <div className="frm_fld crt_btn_fld">
                    <Link to={'/'} className="crt_btn">Sign in</Link>
                  </div>
                </Form>)}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <LoaderModal show={showModal} />
  </>
  )
}

export default ResetPassword
